export const euTaxonomyMinimumSafeguardsSectionIxId =
  'euTaxonomyMinimumSafeguards'

export const netTurnoverNotionId = '3903ed0623e744c6bc3cc05c472500e6'
export const activityTurnoverNotionId = 'a3f63e567c814f199da6da9076188214'
export const capexNotionId = 'f50ea4e49d8c4a71a181e694824f13d1'
export const activityCapexNotionId = '65107f294fa24c34b089de9fad875a5e'
export const opexNotionId = '840c1a7bd7ed4ad38a31c6c07b83191a'
export const activityOpexNotionId = 'fab2f694a4c141bc81a2d7168417908d'
